import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import moment from 'moment';
import ProjectDetailsRow from './ProjectDetailsRow';
import Styles from './ProjectDetailsList.styles';

const ProjectDetailsList = props => (
  <ul style={Styles.list}>
    {props.name && <ProjectDetailsRow label="Name:" value={props.name} />}
    {props.createdAt && (
      <ProjectDetailsRow
        label="Created At:"
        value={moment(props.createdAt).format('dddd, Do MMMM YYYY [at] HH:mm')}
      />
    )}
    {props.updatedAt && (
      <ProjectDetailsRow
        label="Modified:"
        value={moment(props.updatedAt).format('dddd, Do MMMM YYYY [at] HH:mm')}
      />
    )}
    {props.isPrivate && (
      <ProjectDetailsRow label="Access:" value={props.isPrivate ? 'Private' : 'Public'} />
    )}
    {props.link && <ProjectDetailsRow label="Public link:" value={props.link} />}
    {props.owners && (
      <ProjectDetailsRow
        label={Object.keys(props.owners).length > 1 ? 'Owners:' : 'Owner:'}
        value={props.owners}
      />
    )}
  </ul>
);

ProjectDetailsList.defaultProps = {
  name: null,
  createdAt: null,
  updatedAt: null,
  isPrivate: false,
  link: null,
  owners: null,
};

ProjectDetailsList.propTypes = {
  name: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  isPrivate: PropTypes.bool,
  link: PropTypes.string,
  owners: PropTypes.arrayOf(Object),
};

export default Radium(ProjectDetailsList);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ProjectDetailsList/ProjectDetailsList.js